import * as yup from 'yup';

export const getFirmwareFormValidationSchema = (
  firmwareFileId: number | null
) =>
  yup.object().shape({
    name: yup.string().required('Please add a firmware name !'),
    brand: yup.object().nullable().required('Please select one brand!'),
    model: yup.object().nullable().required('Please select one model!'),
    ecu: yup.object().nullable().required('Please select one ECU model!'),
    versionName: yup.string().required('Please add a version name !'),
    versionCode: yup
      .number()
      .integer()
      .positive()
      .typeError('The entered version code is invalid.')
      .required('Please add a version code !'),
    firmwareFileId: yup
      .number()
      .nullable()
      .test(
        'FW file test',
        'Please add one file !',
        () => firmwareFileId !== null
      ),
    status: yup.object().nullable().required('Please select a status !'),
    platform: yup.object().nullable().required('Please select one platform!'),
    description: yup
      .string()
      .max(4000, 'Maximum 4000 characters.')
      .required('Please add a full description !'),
  });
